import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
var _templateObject, _templateObject2;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { BlueElement, register as blueRegister, classMap } from '@onviobr/element';
import { styles } from './color-palette.css';
import { EventType } from '../dms-viewer-interface';
import { palette } from '../palette';
var ColorPalette = /*#__PURE__*/function (_BlueElement) {
  function ColorPalette() {
    var _this;
    _classCallCheck(this, ColorPalette);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ColorPalette, [].concat(args));
    _this.currentColor = void 0;
    return _this;
  }
  _inherits(ColorPalette, _BlueElement);
  return _createClass(ColorPalette, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var buttons = palette.map(function (color, i) {
        return _this2.renderColor(color, i);
      });
      return this.html(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\t\t\t<div class=\"color-palette\">\n\t\t\t\t", "\n\t\t\t</div>\n\t\t"])), buttons);
    }
  }, {
    key: "renderColor",
    value: function renderColor(color, key) {
      var _this$currentColor,
        _this3 = this;
      var outerCellClassMap = classMap({
        'cell-outer': true,
        active: color.toLowerCase() === ((_this$currentColor = this.currentColor) === null || _this$currentColor === void 0 ? void 0 : _this$currentColor.toLowerCase())
      });
      var cellClassMap = classMap({
        cell: true,
        border: color.toLocaleLowerCase() === '#ffffff'
      });
      return this.html(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\t\t\t<button\n\t\t\t\tid=", "\n\t\t\t\tclass=\"cell-container\"\n\t\t\t\t@click=", "\n\t\t\t\tdata-qe-id=\"color ", "\">\n\t\t\t\t<div class=", ">\n\t\t\t\t\t<div class=", " style=\"background-color:", "\">\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</button>"])), key, function () {
        _this3.setColorClick(color);
      }, key, outerCellClassMap, cellClassMap, color);
    }
  }, {
    key: "setColorClick",
    value: function setColorClick(color) {
      this.dispatchEvent(new CustomEvent(EventType.ColorChanged, {
        detail: {
          color: color
        }
      }));
    }
  }], [{
    key: "is",
    get: function get() {
      return 'color-palette';
    }
  }, {
    key: "styles",
    get: function get() {
      return styles;
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        currentColor: {
          type: String
        }
      };
    }
  }]);
}(BlueElement);
export { ColorPalette as default };
export var registerColorPalette = function registerColorPalette() {
  return blueRegister(ColorPalette);
};
